function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  min-width: 230px;\n  margin-top: 10px;\n  @media ",
        " {\n    flex-direction: column;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  min-width: 102px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  max-width: 345px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react';
import { Flex } from 'rebass';
import styled from 'styled-components';
import { mediaQueries } from 'shared/styles';
import { Link } from 'shared/components';
import { ModalContainer, ModalButton, ModalSecondaryHeader, ModalCopy } from 'shared/modals';
var ButtonContainer = styled(Flex)(_templateObject(), mediaQueries.largePhone);
var YesButton = styled(ModalButton)(_templateObject1());
var Copy = styled(ModalCopy)(_templateObject2());
export default observer(function(param) {
    var resolve = param.resolve;
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        isOpen: true,
        onRequestClose: function() {},
        px: "75px",
        py: "44px",
        children: [
            /*#__PURE__*/ _jsx(ModalSecondaryHeader, {
                lowercase: true,
                mb: "18px",
                children: "Switch to a Recreational Order?"
            }),
            /*#__PURE__*/ _jsx(Copy, {
                lineHeight: "20px",
                children: "Your cart contains items that are only available if you have a medical card. Unchecking this box will clear your cart, however you can still shop from our recreational menu!"
            }),
            /*#__PURE__*/ _jsx(ButtonContainer, {
                children: /*#__PURE__*/ _jsx(YesButton, {
                    buttonContainerWidth: "220px",
                    onClick: function() {
                        return resolve(true);
                    },
                    children: "View recreational menu"
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                onClick: function() {
                    return resolve(false);
                },
                color: "#4597e0",
                fontSize: "12px",
                mt: "31px",
                children: "Nevermind, I do have a medical card"
            })
        ]
    });
});
